const initialState = {
  list: [],

  loading: 'idle',
  startDate: null,
  endDate: null,
};

export default initialState;
